export async function FetchFile(file, setUrl) {
    fetch(`${process.env.REACT_APP_API}/candidates/fetch-file/${file}/`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob(); // Extract the response body as a Blob
      })
      .then(blob => {
        // Create a URL for the Blob object
        const url = URL.createObjectURL(blob);
        setUrl(url);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
        // setError(error.message);
      });
  }